export default {
  SET_ALFA_STATUS: function (state, payload) {
    state.alfaCoins = payload;
  }
}
